import { Button, Form, TextInput, useWindowWidth } from '@prishapolicy/shared/ui';
import Image from 'next/image';
import { NextSeo } from 'next-seo';
import React from 'react';
import NavigationLineIcon from 'remixicon-react/NavigationLineIcon';
import { object, string } from 'yup';
import banner from './banner.png';
import mobileBanner from './mobileBanner.png';

const validationSchema = object().shape({
  fullName: string().required('Full Name is required'),
  phoneNumber: string()
    .matches(/^\d{10}$/, 'Phone Number must be exactly 10 digits')
    .required('Phone Number is required'),
  emailId: string().email('Invalid email address').required('Email ID is required'),
  applicationNumber: string().required('Application Number is required'),
});

export const TrackYourPurchase = () => {
  const { isMd } = useWindowWidth();
  return (
    <>
      <NextSeo
        title="Track Policy Status | PrishaPolicy"
        description="Track the status of your PrishaPolicy insurance application or policy using your contact and application details."
      />
      <div className="relative">
        <div className="bg-surface-grey  flex h-[100vh] w-full flex-col justify-center  gap-6 ">
          <div className="  flex w-full flex-col items-center justify-center ">
            <div className="rounded-full bg-blue-100 p-[14px]">
              <div className="rounded-full bg-blue-200 p-[14px]">
                <NavigationLineIcon className="text-primary" />
              </div>
            </div>
            <h1 className="text-title-3 font-bold">Track Policy Status</h1>
          </div>
          <div className="z-10 mb-4 flex justify-center px-4 sm:mt-0 sm:px-10">
            <div className="border-grey-200 w-[960px] rounded-lg border bg-white p-6 shadow-lg ">
              <Form
                initialValues={{
                  fullName: '',
                  phoneNumber: '',
                  emailId: '',
                  applicationNumber: '',
                }}
                validationSchema={validationSchema}
              >
                <div className="mb-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
                  <TextInput name={'fullName'} label="Full Name" />
                  <TextInput name={'phoneNumber'} label="Phone Number" />
                  <TextInput name={'emailId'} label="E-Mail ID" />
                  <TextInput name={'applicationNumber'} label="Policy/Application Number" />
                </div>
                <div className="flex items-center justify-center">
                  <Button text="Track Details" rightIcon="arrowRight" variant="primary" />
                </div>
              </Form>
            </div>
          </div>
          <div className=" absolute bottom-0 flex  w-full justify-center">
            <Image
              src={!isMd ? mobileBanner : banner}
              alt="banner"
              style={{
                objectFit: 'contain',
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TrackYourPurchase;
